export default __webpack_public_path__ + "static/media/key.8b71ff84.png";